import { fileTypes } from 'components/common/types/File.types';
import { FileContent } from 'components/common/types';
import { parseCSVFile, parseExcelFile } from 'lib/FileUpload/fileParser';
import { extractFrameCodes, FrameTableAdapter } from './extractFrameCodes';

const processFrameCSVFile = async (
  file: File,
  marketId?: string,
  isReseller?: boolean,
  requiredHeaders?: string[],
): Promise<FileContent[]> => {
  const rows = await parseCSVFile(file);

  if (!rows.length) return [];

  return extractFrameCodes(FrameTableAdapter.fromRows(rows), marketId, isReseller, {
    requiredHeaders,
    missingHeaderMessage: (label) => `CSV must contain a "${label}" header column`,
  });
};

const processFrameExcelFile = async (
  file: File,
  marketId?: string,
  isReseller?: boolean,
  requiredHeaders?: string[],
): Promise<FileContent[]> =>
  extractFrameCodes(FrameTableAdapter.fromRecords(await parseExcelFile(file)), marketId, isReseller, {
    requiredHeaders,
    missingHeaderMessage: (label) => `The file must contain a "${label}" header column`,
  });

export const processFrameFileContents = async (
  acceptedFile: File,
  marketId?: string,
  isReseller?: boolean,
  requiredHeaders?: string[],
): Promise<FileContent[]> => {
  const fileType = fileTypes[acceptedFile.type];

  if (!fileType) {
    return [];
  }

  return fileType === 'csv'
    ? processFrameCSVFile(acceptedFile, marketId, isReseller, requiredHeaders)
    : processFrameExcelFile(acceptedFile, marketId, isReseller, requiredHeaders);
};
